import script from "./PricingTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./PricingTable.vue?vue&type=script&lang=ts&setup=true"

import "./PricingTable.vue?vue&type=style&index=0&id=d8140138&lang=scss"

const __exports__ = script;

export default __exports__